export default __webpack_public_path__ + "static/media/BaruSymbol.6068f0cb.svg";